module.exports = __webpack_public_path__ + "img/scale-statement.53eeb4e4.svg";